"use strict";
var ApiEligibilityPerson = (function () {
    function ApiEligibilityPerson() {
    }
    ApiEligibilityPerson.fromApiTraveler = function (traveler, correlationId) {
        var eligibilityPerson = new ApiEligibilityPerson();
        eligibilityPerson.firstName = traveler.firstName;
        eligibilityPerson.lastName = traveler.lastName;
        eligibilityPerson.dateOfBirth = traveler.birthDate;
        eligibilityPerson.email = traveler.email;
        eligibilityPerson.correlationId = correlationId.toString();
        if (traveler.address) {
            eligibilityPerson.stateOfResidence = traveler.address.stateOrProvince;
        }
        return eligibilityPerson;
    };
    return ApiEligibilityPerson;
}());
exports.ApiEligibilityPerson = ApiEligibilityPerson;
//# sourceMappingURL=D:/a/1/s/eligibility/src/models/api-eligibility-person.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/models/api-eligibility-person.model.js